import type { VariantProps } from 'class-variance-authority'
import { sectionVariants, sectionWrapperVariants } from '@/components/layout/section.variants'
import { cn } from '@/lib/cn'

export interface SectionProps
  extends React.HTMLAttributes<HTMLElement>,
    VariantProps<typeof sectionVariants> {
  as?: 'section' | 'div' | 'header' | 'footer'
}

export function Section({
  className,
  as: Tag = 'section',
  surface,
  padding,
  paddingTop,
  paddingBottom,
  clipped,
  ...props
}: SectionProps) {
  return (
    <Tag
      className={cn(
        sectionVariants({ surface, padding, paddingTop, paddingBottom, clipped }),
        className,
      )}
      {...props}
    />
  )
}

export interface SectionWrapperProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof sectionWrapperVariants> {}

export function SectionWrapper({
  className,
  layout,
  centered,
  gap,
  width,
  padding,
  outlineCard,
  ...props
}: SectionWrapperProps) {
  return (
    <div
      className={cn(
        sectionWrapperVariants({ layout, centered, gap, width, padding, outlineCard }),
        className,
      )}
      {...props}
    />
  )
}
